import { render, staticRenderFns } from "./FansPortraitN.vue?vue&type=template&id=28bab417&scoped=true"
import script from "./FansPortraitN.vue?vue&type=script&lang=js"
export * from "./FansPortraitN.vue?vue&type=script&lang=js"
import style0 from "./FansPortraitN.vue?vue&type=style&index=0&id=28bab417&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bab417",
  null
  
)

export default component.exports